<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17E230v/tc-custom/9781439676691.jpg?1702530410408" alt="This image is the cover for the book Hidden History of Monroe County, Michigan, Hidden History"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hidden History of Monroe County, Michigan, Hidden History
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Often overshadowed by its larger neighbors, Monroe County offers a rich tapestry of history for those willing to look.</b></p><br/><p>French-Canadian settlers left behind legends of monsters, ghosts, and witches. In war time, the community answered the call to arms with more soldiers per capita than any other county in the nation and proved a suitable hometown to take refuge between gun shots from none other than George Armstrong Custer. Like most communities, its sordid past reveals crimes and tragedies--including body snatching. More recently, a partial nuclear meltdown brought the city to the brink of disaster, but Monroe not only survived but now thrives.</p><br/><p>Join local author Shawna Lynn Mazur for a trip through little-known and forgotten parts of Monroe County's past. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Shawna Lynn Mazur
      </h2>
      
      <p class="authorDescription body article">Shawna Lynn Mazur is a Monroe native. In 2007, Shawna was hired by the Monroe County Historical Museums. With a bachelor's degree in history and literature and a love of history, research and writing, she wrote numerous articles and conducted the museum's popular Lantern Tours for four years. She has also published in <I>Michigan History</I> magazine, the Little Big Horn Associates newsletter and the local newspaper. As an interpretive ranger at the River Raisin National Battlefield Park, she contributed to growing the park and developing some of its interpretive programs, publications and curriculums. She is currently working on a book for the National Park Service.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d331bcf6